import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fetchMe = async () => {
  const { data } = await api.get("/auth/me");
  return data;
};

// --- Emergent-managed Google OAuth ---
export const login = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const params = new URLSearchParams(window.location.search);
  const ref = params.get("ref");
  if (ref) {
    try { window.localStorage.setItem("mythos_ref", ref); } catch (e) { /* ignore */ }
  }
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const logout = async () => {
  await api.post("/auth/logout");
};

export const exchangeSession = async (session_id, referral_code) => {
  const { data } = await api.post("/auth/session", { session_id, referral_code });
  return data.user;
};

// --- Email/password auth ---
export const registerEmail = async ({ email, password, name, referral_code }) => {
  const { data } = await api.post("/auth/register", { email, password, name, referral_code });
  return data.user;
};

export const loginEmail = async ({ email, password }) => {
  const { data } = await api.post("/auth/login", { email, password });
  return data.user;
};

export const requestPasswordReset = async (email) => {
  const { data } = await api.post("/auth/forgot-password", { email });
  return data;
};

export const resetPassword = async ({ token, password }) => {
  const { data } = await api.post("/auth/reset-password", { token, password });
  return data;
};

// --- Age confirmation (18+) ---
export const confirmAge = async () => {
  const { data } = await api.post("/me/confirm-age", { confirmed: true });
  return data;
};

// --- Voice ---
export const transcribeAudio = async (blob) => {
  const form = new FormData();
  form.append("audio", blob, "recording.webm");
  const { data } = await api.post("/voice/transcribe", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.text;
};

export const speakText = async ({ text, companion_id, voice, engine }) => {
  const { data } = await api.post("/voice/speak", { text, companion_id, voice, engine });
  return data; // { audio_base64, content_type, voice }
};

// --- File upload ---
export const uploadImage = async (file, kind = "misc") => {
  const form = new FormData();
  form.append("kind", kind);
  form.append("file", file);
  const { data } = await api.post("/upload/image", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { url, path, file_id }
};

// Convert a backend-relative /api/files/... URL into an absolute one
export const fileUrl = (urlOrPath) => {
  if (!urlOrPath) return urlOrPath;
  if (/^https?:/i.test(urlOrPath)) return urlOrPath;
  if (urlOrPath.startsWith("/api/")) return `${BACKEND_URL}${urlOrPath}`;
  return urlOrPath;
};

// Normalize FastAPI error details (string | validation array | obj) to a string.
export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
